import SlidingPanel from './SlidingPanel';

export default SlidingPanel;



// WEBPACK FOOTER //
// ./src/components/SlidingPanel/index.js